import { createSlice } from "@reduxjs/toolkit";
import {      reKycValidatePersonalDetailsThunk } from "./thunk";

export const initialState = {
  reKyc_validateDetailsData: [],
  reKyc_validateDetailsError: '', // for error message
  reKyc_validateDetailsLoading: false,
  
  
};

const ReKycValidateDetails = createSlice({
  name: "ReKycValidateDetails",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(reKycValidatePersonalDetailsThunk.pending, (state) => {
      state.reKyc_validateDetailsLoading = true ;
      state.reKyc_validateDetailsData= [];
      state.reKyc_validateDetailsError='';

  });
    builder.addCase(reKycValidatePersonalDetailsThunk.fulfilled, (state, action) => {
        state.reKyc_validateDetailsData = action.payload.data;
        state.reKyc_validateDetailsLoading = false ;
    });
    builder.addCase(reKycValidatePersonalDetailsThunk.rejected, (state, action) => {
      state.reKyc_validateDetailsError = action.error?.message || action.payload?.message || "An unknown error occurred";
        state.reKyc_validateDetailsLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = ReKycValidateDetails.actions

export default ReKycValidateDetails.reducer;